import { ChangeDetectorRef ,ViewRef,Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { DialogService, StateService,DossierService,
TiersService
 } from '../../../../../services'


import {
	Observable,
	BehaviorSubject,	
} from "rxjs";

const KEY = 'groupe'

@Component({
  selector: 'atyl-groupe-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
@Stringable({
  path: 'views/partials/content/general/groupe',
  key: KEY,
})
export class GroupeListComponent implements OnInit {

  @Input() loading:BehaviorSubject<any>=new BehaviorSubject<any>(null);
  
  @StringableValues(KEY) strings: any
  
  @Input() dossier: any;
  @Input() perso: boolean=true;
  @Input() instruction: any;
  
  groupeInput:any;
   
  @Output() onGroupSelected = new EventEmitter<any>();
  
  activeButton:boolean=false;

  forms:any[]=[];
  
  groupes:any[]=[];
  nodeCount:number=0;

  id:any;
  
  associateButton:boolean=true;

  refreshUser: any=null;
  refreshDossier: any=null;

  user:any;
  
  @Input() types: any[]=[];
  
 
  
  constructor(
    private changeDetector: ChangeDetectorRef,
    private stateService: StateService,
    private dialogService: DialogService,
    private dossierService: DossierService,
    private changeDetectorRef: ChangeDetectorRef,
     private tiersService: TiersService
  ) { }

  ngOnInit() {
	this.refreshUser=this.stateService.user.subscribe((user) => {
		 		console.log("user dossier user",user);
		 		if (user) {
		                this.user = user
		                console.log("user dossier",this.user)
						this.loadGroupe();
		            }
		})
		
	 
	 
		 
		 
	 	
     
    
  }
  
  ngOnDestroy() {
	  	
	  	if (this.refreshUser)
	  		this.refreshUser.unsubscribe();
    
  }
  
   loadGroupe() {
	   console.log("GroupeComponent load ",this.dossier,this.user);	
	   
	   let _opts:any={
		   
	   }
	  this.groupes=[];
	   
	   
	   
	   if (this.user!=undefined) {
			this.id=this.user.id;
	   }
	  
	      
	    
	   this.tiersService.getGroupe(this.id,_opts).subscribe(
		   (res: JSONRpcResponse) => {
				console.log("GroupeComponent loaded",res);
				if (res.result 
					&& res.result!=undefined
				) {
					this.groupes=res.result;
					this.nodeCount=this.groupes.length;
					this.detectChanges();
				}
					
			}
	   );
	   	
   }
  
   detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }
	
	hexToRgbA(hex: string, alpha: any = 255) {
				let color: any
				let newAlpha = Number.parseInt(alpha, 10)

				if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
					color = hex.substring(1).split('')
					if (color.length == 3) {
						color = [color[0], color[0], color[1], color[1], color[2], color[2]]
					}
					color = '0x' + color.join('')
					return 'rgba(' + [(color >> 16) & 255, (color >> 8) & 255, color & 255].join(',') + ',' + newAlpha / 255 + ')'
				}
		}
	groupeSelected(event:any) {
			//console.log("userSelected",event);
		if(event && event!=null){
			this.onGroupSelected.emit(this.groupeInput);
		}

	}
  

}
